// eslint-disable-next-line no-restricted-exports
export { default } from './Accordion';
export * from './Accordion';
